import './styles.scss'

import React from 'react'
import { useValues } from 'kea'
import PropTypes from 'prop-types'

import FloatingHeader from 'lib/components/floating-header'

import EDM from '~/scenes/edm'

import SearchHeaderElements from './header-elements/search-header-elements'
import SearchBox from './search-box'
import HeaderElements from './header-elements'
import FloatingHeaderElements from './header-elements/floating-header-elements'

import sceneLogic from './logic'

const Header = props => {
  const { isSearchBoxVisible, auxAvatar, headerFavouritesCount, isInboxThreadPage } = useValues(sceneLogic)
  const { categorySuggestions, isHomePage, isSearchPage, isRecruitmentPage, isLoggedIn } = props

  if (isSearchPage || isInboxThreadPage) {
    return (
      <SearchHeaderElements
        {...props}
        visiblerule={`${isSearchBoxVisible ? 'show-flex-over-640-screen' : ''}`}
        auxAvatar={auxAvatar}
        headerFavouritesCount={headerFavouritesCount}
      />
    )
  }

  return (
    <div>
      {isSearchBoxVisible ? (
        <div className='react-header hide-flex-over-640-screen'>
          <SearchBox categorySuggestions={categorySuggestions} />
        </div>
      ) : null}
      <HeaderElements
        {...props}
        visiblerule={`${isSearchBoxVisible ? 'show-flex-over-640-screen' : ''}`}
        auxAvatar={auxAvatar}
        headerFavouritesCount={headerFavouritesCount}
      />
      {(isRecruitmentPage || isHomePage) && (
        <FloatingHeader
          triggerSelector={`${isRecruitmentPage ? '.welcome-section-overlay-content-title' : '.home-page-search-box'}`}
          minWidth={0}
        >
          <FloatingHeaderElements
            {...props}
            visiblerule={`${isSearchBoxVisible ? 'show-flex-over-640-screen' : ''}`}
            auxAvatar={auxAvatar}
            headerFavouritesCount={headerFavouritesCount}
          />
        </FloatingHeader>
      )}
      {isLoggedIn && <EDM />}
    </div>
  )
}

Header.propTypes = {
  categorySuggestions: PropTypes.array,
  isHomePage: PropTypes.bool,
  isSearchPage: PropTypes.bool,
  isRecruitmentPage: PropTypes.bool,
  isInboxThreadPage: PropTypes.bool,
  isLoggedIn: PropTypes.bool
}

export default Header
